export default __webpack_public_path__ + "static/media/rainbow.6d0d2612.png";